import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index'
import store from '@/store/index'
import i18n from '@/lang'
import TsaUI from 'tsa-ui';
import '@/router/index/guard';
import 'tsa-ui/lib/theme-chalk/index.css';
import {set, get } from '@/utils/localStorage'
import layer from "vue-layer";
import "vue-layer/lib/vue-layer.css";
import '@/assets/css/common.less'
import{partnerType,sourceType} from '@/config/index'

Vue.use(TsaUI)
Vue.config.productionTip = false
Vue.prototype.$setlocalStorage = set;
Vue.prototype.$getlocalStorage = get;
Vue.prototype.$layer = layer(Vue);
import { Mymessage, diaMessage } from '@/utils/common';
Vue.prototype.$msg = Mymessage;
Vue.prototype.$diamsg = diaMessage;
Vue.prototype.$partnerType = partnerType;
Vue.prototype.$sourceType = sourceType;

import TsaEnvironmentCheck from '@/plugins/EnvironmentCheck'
Vue.use(TsaEnvironmentCheck);

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app')